module.exports = __webpack_public_path__ + "static/speaker_bg-92db68c17f64952381da6017bc089f7f.png";